const UserRole = {
    ROOT: 'root',
    ADMIN: 'admin',
    EDITOR: 'editor',
    CREATOR: 'creator',
};

export default UserRole;
